import { useRef } from 'react'

export const InputFileWrapper = (props: {
  accept?: string
  children: React.ReactNode
  onChangeFile: React.ChangeEventHandler<HTMLInputElement>
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null)

  const onWrappedClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click()
    }
  }

  return (
    <>
      <div onClick={onWrappedClick}>{props.children}</div>
      <input
        type='file'
        accept={props.accept}
        ref={fileInputRef}
        style={{ display: 'none' }}
        onChange={props.onChangeFile}
      />
    </>
  )
}
